import { RawSortBy } from './createSortByQueryParam.types';

export default (rawSortBy: RawSortBy, defaultParameter?: string, uppercase = true) => {
    const field = rawSortBy[0]?.id || '';
    const currentSort = uppercase ? field.toUpperCase() : field;

    if (!currentSort) return defaultParameter;

    return rawSortBy[0]?.desc ? `${currentSort},desc` : `${currentSort},asc`;
};
